import React, { useState } from "react";
import { TextArea } from "@progress/kendo-react-inputs";
import { Hint } from "@progress/kendo-react-labels";
import "./InputRenderer.scss";
import { number } from "../../../../config";

const InputRenderer = ({ element, onChange, showResponses = false, isGridElement }) => {
  const { properties = {}, value = "" } = element;
  const {
    placeholder = "Enter text...",
    required = false,
    defaultValue = "",
    isMultiLine = false,
    lineCount = 1,
    showChipName: showChipNameRaw,
    min, max
  } = properties;
  const showChipName = showChipNameRaw === false ? false : true;
  const [inputValue, setInputValue] = useState(value ? value : undefined);

  const handleChange = (e) => {
    setInputValue(e.target.value);
    onChange(e.target.value);
  };

  return (
    <div className={`input-renderer ${isGridElement ? "mb-0" : "mb-3"}`}>
      {showChipName && (
        <label htmlFor={`${element?.id}-input`} className='form-label'>
          {element?.name}
        </label>
      )}
      <div className='d-flex'>
        <TextArea
          placeholder={showResponses ? undefined : placeholder}
          value={inputValue}
          onChange={handleChange}
          defaultValue={showResponses ? undefined : defaultValue}
          required={required}
          validationMessage={"This field is required"}
          className={`input-field w-100 ${showResponses ? "disabled" : ""}`}
          rows={lineCount || 1}
          resizable={isMultiLine ? "vertical" : "none"}
          minLength={min}
          maxLength={max}
          spellCheck={true}   
          readOnly={showResponses}
        />
        {required && !showResponses && <span className='required-asterisk text-danger ms-1 ml-1'>*</span>}
      </div>
      {max && !showResponses && <Hint
          direction={"end"}
          className="mr-2"
        >
          {inputValue ? inputValue?.length : defaultValue ? defaultValue?.length : number.ZERO} / {max}
        </Hint>}
    </div>
  );
};

export default InputRenderer;
